<template>
  <section class="feature_view_wrapper">
    <Feature :keyFeatList="keyFeatList"></Feature>
    <Footer></Footer>
    <FootBanner v-show="!isPc && !isIOS"></FootBanner>
  </section>
</template>

<script>
import Feature from "@/components/Feature.vue";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  name: "FeatureView",
  components: {
    Feature,
    Footer,
    FootBanner,
  },
  data() {
    return {};
  },
  methods:{
    t(d,ar){
      if(this.$route.query.lang == "ar"){
        if(ar != undefined) return ar;
        else return d;
      } else {
        return d;
      }
    }
  },
  computed: {
    keyFeatList() {
      return [
         {
          imgURL: require("../assets/img/pic_new_features_1.png"),
          imgAlt: "ToTok is a free video call and conference call app",
          infoSummary: this.t("Unlimited Free Calling","مكالمات مجانية غير محدودة"),
          info: this.t("Connect with your family and friends around the world with ToTok audio and video calling for free.","تواصل مع عائلتك وأصدقائك في جميع أنحاء العالم من خلال مكالمات ToTok الصوتية والمرئية مجاناً."),
          fillColor: "#f9f1f8",
          splitLineColor: "#5b81d6",
        },
        {
          imgURL: require("../assets/img/pic_new_features_2.png"),
          imgAlt: "Totok has face filters and video filters",
          infoSummary: this.t("Retouch Filter for Video Calls","تنقيح مرشح المكالمات المرئية"),
          info: this.t("Use the built-in retouch filter to smooth your skin during video calls.","استخدم مرشح التنقيح المدمج لتنعيم بشرتك أثناء المكالمات المرئية."),
          fillColor: "#f8f8f8",
          splitLineColor: "#3fbc89",
        },
        {
          imgURL: require("../assets/img/pic_new_features_3.png"),
          imgAlt: "send voice messages and free texts on ToTok",
          infoSummary: this.t("Chatting is More Fun","دردشة أكثر متعة"),
          info: this.t("Send voice messages, stickers, GIFs, photos, videos, location, files, and much more."," إرسال رسائل صوتية وملصقات وملفات جي آي إف (GIF) وصور ومقاطع الفيديو والموقع الجغرافي والملفات وغير ذلك الكثير."),
          fillColor: "#e7ebf3",
          splitLineColor: "#d83076",
        },
        {
          imgURL: require("../assets/img/pic_new_features_4.png"),
          imgAlt: "set chat wallpaper and chat background on totok",
          infoSummary: this.t("Chat Wallpaper","خلفيات الدردشة"),
          info: this.t("Customize your chats with ToTok's selected wallpapers or any static or motion pictures stored on your device.","قم بتخصيص دردشاتك مع خلفيات ToTok المحددة أو أي صور ثابتة أو متحركة مخزنة على جهازك."),
          fillColor: "#faf4ed",
          splitLineColor: "#ea8f39",
        },
        {
          imgURL: require("../assets/img/pic_new_features_5.png"),
          imgAlt: "delete sent messages on totok",
          infoSummary: this.t("Delete Sent Messages","حذف الرسائل المرسلة"),
          info: this.t("Wishing you didn't send that message? Here is 'a wish come true'. With this feature, you can easily take back what you did not mean to send.","أتمنى أنك لم ترسل هذه الرسالة؟ هنا \"أمنية تتحقق\" عبر استخدام هذه الميزة  يمكنك بسهولة استعادة ما لم تقصد إرساله."),
          fillColor: "#f2f6f0",
          splitLineColor: "#ea8f39",
        },
        {
          imgURL: require("../assets/img/pic_new_features_6.png"),
          imgAlt: "enjoy free conference call and group call on totok",
          infoSummary: this.t("20-Person Group Video Calls","مكالمات مرئية جماعية لـ 20 شخصاً"),
          info: this.t("Enjoy group calls of up to 20 participants. Talk with your family, friends, or make conference calls with your coworkers anywhere, anytime.","استمتع بمكالمات جماعية تصل إلى 20 مشاركاً، تحدث مع عائلتك أو أصدقائك أو قم بإجراء مكالمات جماعية مع زملائك في العمل في أي مكان وفي أي وقت."),
          fillColor: "#faf4ed",
          splitLineColor: "#ea8f39",
        },
        {
          imgURL: require("../assets/img/pic_new_features_7.png"),
          imgAlt: "Enjoy group calls of up to 20 participants. ",
          infoSummary: this.t("10,000-Person Group Chats","دردشات مجموعة 10000 شخص"),
          info: this.t("Make the most of ToTok 10,000-person group chat by establishing your own community or joining communities that share the same interests.","حقق أقصى استفادة من الدردشة الجماعية لـ ToTok التي تبلغ 10000 شخص من خلال إنشاء مجتمعك الخاص أو الانضمام إلى المجتمعات التي تشترك في نفس الاهتمامات."),
          fillColor: "#f9f1f8",
          splitLineColor: "#ea8f39",
        },
        {
          imgURL: require("../assets/img/pic_new_features_8.png"),
          imgAlt:
            "ToTok has a local time feature to let you know other party’s local time",
          infoSummary: this.t("Other Party's Time","وقت الطرف الآخر"),
          info: this.t("Avoid disturbing your family and friends living abroad by checking out their local time on the one-on-one chat.","تجنب إزعاج عائلتك وأصدقائك الذين يعيشون في الخارج عن طريق معرفة التوقيت المحلي لديهم في الدردشة الفردية."),
          fillColor: "#faf4ed",
          splitLineColor: "#ea8f39",
        },
      ];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
};
</script>
<style lang="stylus" scoped>
.feature_view_wrapper{
    position relative;
    top:55px;
}
@media only screen and (max-width: 700px) {
    .feature_view_wrapper{
        position relative;
        top:0px;
    }
}
</style>
